import React from "react";
import { IconButton, InputAdornment } from "@mui/material";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";

export function createPasswordVisibilitySlotProps(isVisible, setVisible) {
  return {
    input: {
      endAdornment: (
        <InputAdornment position="end">
          <IconButton
            onClick={() => setVisible(!isVisible)}
            onMouseDown={(event) => event.preventDefault()}
            edge="end"
            sx={{ color: "text.secondary" }}
          >
            {isVisible ? <Visibility /> : <VisibilityOff />}
          </IconButton>
        </InputAdornment>
      ),
    },
  };
}
